import React from 'react';
import PropTypes from 'prop-types';
import CloverPaymentForm from './cloverForm';

function PaymentClover({ clientinfo, code }) {
  console.log('🚀 ~ PaymentClover ~ clientinfo:', clientinfo);
  return (
    <div className="App">
      <h1>Clover Payment Integration</h1>
      <CloverPaymentForm clientinfo={clientinfo} code={code} />
    </div>
  );
}

PaymentClover.propTypes = {
  code: PropTypes.string.isRequired,
  clientinfo: PropTypes.func.isRequired
};

export default PaymentClover;
